import StreetViewScreen from "@/screens/StreetViewScreen"

export default StreetViewScreen
